import React from "react";

const GameCard = (props) => {
    const { title, des, img, bgColor } = props.item;

    return (
        <div className="col l-6 m-12 c-12">
            <div className="gameCard__item">
                <div className="gameCard__item__img">
                    <img className={`${bgColor}`} src={img} alt={title} />
                </div>
                <h4 className="textBox__title--mid">{title}</h4>
                <p className="textBox__text">{des}</p>
            </div>
        </div>
    );
};

export default GameCard;
